import React, { useCallback, useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import { listaUsuariosPaginados, deletaUsuario, deletaUsuariosMassa } from '../../services/mysql'

const nomesPerfis = {
    ATLETA: 'Telespectador',
    ATLETA_PROFISSIONAL: 'Atleta',
    PRODUTOR: 'Produtor',
    ADMIN: 'Administrador'
};

export default function Usuarios() {
    const [usuarios, setUsuarios] = useState([])
    const [selecionados, setSelecionados] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState("");
    const [perfil, setPerfil] = useState("");
    const [cpfBusca, setCpfBusca] = useState("");
    const [loading, setLoading] = useState(false);
    const pageSize = 25;

    const carregarUsuarios = useCallback(async (page, signal) => {
        setLoading(true);
        try {
            const res = await listaUsuariosPaginados({ page, limit: pageSize, perfil, cpf: cpfBusca }, signal);
            if (signal?.aborted) return;
            setUsuarios(res.usuarios);
            setTotalPages(res.totalPages);
            setSelecionados([]);
            setCurrentPage(res.currentPage);
        } catch (error) {
            if (signal?.aborted) return;
            mensagemErro('Não foi possível carregar os usuários. Tente novamente.');
        } finally {
            if (!signal?.aborted) setLoading(false);
        }
    }, [perfil, cpfBusca]);

    useEffect(() => {
        const controller = new AbortController();
        carregarUsuarios(currentPage, controller.signal);
        return () => controller.abort();
    }, [currentPage, carregarUsuarios]);

    const mudarPagina = (novaPagina) => {
        if (!loading && novaPagina >= 1 && novaPagina <= totalPages) setCurrentPage(novaPagina);
    };

    const searchUsuario = (event) => {
        event.preventDefault();
        const cpf = search.replace(/\D/g, '');
        if (search.trim() && cpf.length !== 11) {
            mensagemAlerta('Digite um CPF com 11 dígitos');
            return;
        }
        setCurrentPage(1);
        setCpfBusca(cpf);
    };

    const toggleSelecionado = (id) => {
        setSelecionados((prev) =>
            prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
        );
    };

    const excluirSelecionados = () => {
        Swal.fire({
            title: 'Aviso',
            text: 'Você deseja excluir todos esses usuarios?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                console.log(selecionados)
                mensagemLoading('Realizando exclusão dos usuarios..')
                deletaUsuariosMassa({ ids: selecionados }).then((res) => {
                    if (res.erro) {
                        mensagemErro(res.message)
                    } else {
                        mensagemSucesso(res.message)
                    }
                })
            }
        });
    };

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }

    function removeUsuario(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o usuario ' + item.nome + ' ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Deletando Usuario..')
                deletaUsuario(item.id).then((res) => {
                    console.log(res)
                    if (res.erro) {
                        mensagemErro(res.message)
                    } else {
                        mensagemSucesso('Usuário removido com sucesso')
                    }
                })

            }
        });
    }

    const handlePerfil = (event) => {
        setPerfil(event.target.value);
        setCurrentPage(1);
    };
    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            carregarUsuarios(currentPage);
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row card-body'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Usuários</h5>
                                        </div>
                                        {selecionados.length > 1 ?
                                            <div className='col-md-2' style={{ padding: 10 }}>
                                                <button onClick={() => excluirSelecionados()} className="btn btn-danger d-grid " type="submit">Remover </button>
                                            </div>
                                            :
                                            null
                                        }
                                        <div className="col-md-2">
                                            <select id="defaultSelect" className="form-select" onChange={handlePerfil} value={perfil} >
                                                <option value="">Todos os perfis</option>
                                                <option value={'ADMIN'}  >Admin</option>
                                                <option value={'ATLETA'}  >Telespectadores</option>
                                                <option value={'ATLETA_PROFISSIONAL'}  >Atletas</option>
                                                <option value={'PRODUTOR'}>Produtor</option>
                                            </select>
                                        </div>
                                        <form className="col-md-5 d-flex gap-2" onSubmit={searchUsuario}>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                aria-label="CPF do usuário"
                                                placeholder="Buscar usuário por CPF"
                                                className="form-control"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                            <button className="btn btn-primary" type="submit" disabled={loading}>Buscar</button>
                                            <button className="btn btn-outline-primary" type="button" disabled={loading} onClick={() => {
                                                setSearch('');
                                                setCpfBusca('');
                                                setCurrentPage(1);
                                            }}>Limpar</button>
                                        </form>
                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Ordem</th>
                                                    <th>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) =>
                                                                setSelecionados(
                                                                    e.target.checked
                                                                        ? usuarios
                                                                            .filter((usuario) => usuario.perfil !== "ADMIN")
                                                                            .map((usuario) => usuario.id)
                                                                        : []
                                                                )
                                                            }
                                                            checked={
                                                                selecionados.length > 0 &&
                                                                selecionados.length ===
                                                                usuarios
                                                                .filter((usuario) => usuario.perfil !== "ADMIN").length
                                                            }
                                                        />
                                                    </th>
                                                    <th>Nome</th>
                                                    <th>CPF</th>
                                                    <th>Email</th>
                                                    <th>Perfil</th>
                                                    <th>Deletar</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0">
                                                {usuarios
                                                .map((usuario, index) =>
                                                    <tr key={usuario.id}>
                                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                                        <td>
                                                            {usuario.perfil !== "ADMIN" && (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selecionados.includes(usuario.id)}
                                                                    onChange={() => toggleSelecionado(usuario.id)}
                                                                />
                                                            )}
                                                        </td>
                                                        <td>{usuario.nome}</td>
                                                        <td>{usuario.cpf}</td>
                                                        <td>{usuario.email}</td>
                                                        <td>{nomesPerfis[usuario.perfil] || usuario.perfil}</td>
                                                        <td>
                                                            <button onClick={() => usuario.perfil !== 'ADMIN' ? removeUsuario(usuario) : null} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                <span className="tf-icons bx bx-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                                {usuarios.length === 0 && !loading && (
                                                    <tr><td colSpan={7} className="text-center">Nenhum usuário encontrado</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center align-items-center gap-3 my-3" aria-label="Paginação de usuários">
                                            <button className="btn btn-primary" onClick={() => mudarPagina(currentPage - 1)} disabled={loading || currentPage <= 1}>Anterior</button>
                                            <span aria-live="polite">{loading ? 'Carregando usuários...' : `Página ${currentPage} de ${Math.max(1, totalPages)}`}</span>
                                            <button className="btn btn-primary" onClick={() => mudarPagina(currentPage + 1)} disabled={loading || currentPage >= totalPages}>Próximo</button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}
